import { BasicClient } from '@/utils/httpClient'

export default class Signatures {
  client
  constructor() {
    this.client = new BasicClient()
  }

  licenseType(typeId) {
    let body = {
      type_id: typeId
    }
    return this.client.exec('/licensesUser/available', 'POST', body)
  }
  getLicenseTypes(orderBy, orderType) {
    let order = ''
    if (orderBy && orderType) {
      order = `?orderBy=${orderBy}&orderType=${orderType}`
    }
    return this.client.exec(`/v2/licensesUser/types${order}`, 'GET')
  }
  getLicenseTypesManager() {
    return this.client.exec(`/licensesAdmin/types`, 'GET')
  }
  getHolidays(idpolitica, from, to, rowsPerPage = null, page = null) {
    let pagination = ''
    if (rowsPerPage && page) {
      pagination = `?pagination=${rowsPerPage},${page},0`
    }
    let params = {
      idp: idpolitica,
      fecha_desde: from,
      fecha_hasta: to
    }
    return this.client.exec(
      `/licensesAdmin/holidayParams${pagination}`,
      'POST',
      params
    )
  }
  deleteHoliday(id) {
    return this.client.exec(`/licensesAdmin/holiday/${id}`, 'DELETE')
  }
  getConfig() {
    return this.client.exec('/licensesUser/config', 'GET')
  }
  getBalanceByType(licTypeId) {
    return this.client.exec('/licensesUser/available', 'POST', {
      type_id: licTypeId
    })
  }
  getBalanceByTypes(params) {
    return this.client.exec(`/manager/myteam/available/${params.id}`, 'POST', {
      type_id: params.typeId
    })
  }
  getApprovers() {
    return this.client.exec('/licensesUser/approvers', 'GET')
  }

  getHistoryLicenses(perPage, page, orderBy, descending) {
    let pagination = ''
    let order = ''
    if (perPage && page) {
      pagination = `?pagination=${perPage},${page},0`
    }
    if (orderBy) {
      let type = descending ? 'desc' : 'asc'
      order = `&orderBy=${orderBy}&orderType=${type}`
    }

    return this.client.exec(
      `/v2/licensesUser/history${pagination}${order}`,
      'GET'
    )
  }

  getSpecialRequests(perPage, page, orderBy) {
    let pagination = ''
    let order = ''
    if (perPage && page) {
      pagination = `?pagination=${perPage},${page},0`
    }
    if (orderBy) {
      let type = 'desc'
      order = `&orderBy=${orderBy}&orderType=${type}`
    }

    return this.client.exec(
      `/v2/licensesUser/specialhistory${pagination}${order}`,
      'GET'
    )
  }

  getSpecialRequestsManager(userId, perPage, page, orderBy) {
    let pagination = ''
    let order = ''

    if (perPage && page) {
      pagination = `?pagination=${perPage},${page},0`
    }

    if (orderBy) {
      let type = 'desc'
      order = `&orderBy=${orderBy}&orderType=${type}`
    }

    const hasUserId = userId && userId.userId != null

    const endpoint = hasUserId
      ? `/manager/myteam/other-absencesVp/${userId.userId}${pagination}${order}`
      : `/manager/myteam/other-absencesVp/${pagination}${order}`

    return this.client.exec(endpoint, 'GET')
  }

  getHistoryByType(userId, typeId) {
    return this.client.exec('/licensesUser/historyByType/' + userId, 'POST', {
      type_id: typeId
    })
  }

  getBalanceByTypeAndUser(userId, typeId) {
    return this.client.exec('/licensesUser/available/' + userId, 'POST', {
      type_id: typeId
    })
  }

  getLicenseMovements(licenseId) {
    return this.client.exec(`/licensesUser/movements/${licenseId}`, 'GET')
  }

  getPendingAprovalLicenses(idUser, perPage, page, orderBy, descending) {
    let pagination = ''
    let order = ''
    if (perPage && page) {
      pagination = `?pagination=${perPage},${page},0`
    }
    if (orderBy) {
      let type = descending ? 'desc' : 'asc'
      order = `&orderBy=${orderBy}&orderType=${type}`
    }

    return this.client.exec(
      `/v2/licensesUser/pendingApproval/${idUser}${pagination}${order}`,
      'GET'
    )
  }

  validPass(pass) {
    let body = {
      pass: pass
    }
    return this.client.exec('/users/isValidPass', 'POST', body)
  }

  ApprovalPendingLicenses(
    idsol,
    observation,
    user_approver,
    password,
    default_user
  ) {
    let body = {
      idsol: idsol,
      observation: observation,
      user_approver: user_approver,
      password: password,
      default_user: default_user
    }
    return this.client.exec('/licensesAdmin/approve', 'POST', body)
  }

  getCalendarLicenses(start, end) {
    let params = {
      fecha_desde: start,
      fecha_hasta: end
    }
    return this.client.exec('/licensesUser/calendarParams', 'POST', params)
  }

  deleteRequestLicense(id, comment) {
    return this.client.exec(`/licensesUser/requests/${id}`, 'DELETE', {
      comment: comment
    })
  }
  calculateDays(
    dateFrom,
    dateTo,
    licenseTypeId,
    daysOff,
    holiday_types = [],
    halfDay,
    hoursRange
  ) {
    let params = {
      date_from: dateFrom,
      date_to: dateTo,
      type_id: licenseTypeId
    }
    if (daysOff !== null) {
      params.daysoff = daysOff.toString()
    }
    if (halfDay) {
      params.half_day = 1
      if (hoursRange) params.hours_range = hoursRange
    }
    if (holiday_types.length > 0) {
      params.holiday_types = holiday_types
    }

    return this.client.exec('/licensesUser/calculate', 'POST', params)
  }
  requestLicense(
    dateFrom,
    dateTo,
    licenseTypeId,
    comment,
    halfDay,
    idApprover,
    daysOff,
    severancePay,
    idLoad,
    hoursRange,
    anticipatePayment,
    holiday_types = []
  ) {
    let params = {
      date_from: dateFrom,
      date_to: dateTo,
      type_id: licenseTypeId,
      comment: comment
    }

    if (halfDay) {
      params.half_day = 1
      if (hoursRange) params.hours_range = hoursRange
    }

    if (anticipatePayment === 1) {
      params.anticipatePayment = 1
    }
    if (holiday_types.length > 0) {
      params.holiday_types = holiday_types
    }

    if (idApprover) {
      params.id_approver = idApprover
    }

    if (daysOff !== null) {
      params.daysoff = daysOff.toString()
      //Agregar los francos seleccionados a la observacion

      //Agregar los feriados que figuran dentro del rango seleccionados en las observaciones solo si config.tiene_feriados == true
    }

    if (severancePay !== null) {
      params.severance_pay = severancePay
    }

    if (idLoad) {
      params.categoryDocumentTypeUserId = idLoad
    }

    return this.client.exec('/licensesUser/requests', 'POST', params)
  }

  searchLicenses(filters, perPage, page, orderBy, descending) {
    let pagination = ''
    let order = ''
    if (perPage && page) {
      pagination = `?pagination=${perPage},${page},0`
    }
    if (orderBy) {
      let type = descending ? 'desc' : 'asc'
      order = `&orderBy=${orderBy}&orderType=${type}`
    }

    let params = {}
    if (filters.userId) params.user_id = [filters.userId]
    if (filters.licenseTypeId) params.type_id = filters.licenseTypeId
    if (filters.periodoDesde) params.periodo_desde = filters.periodoDesde
    if (filters.periodoHasta) params.periodo_hasta = filters.periodoHasta
    if (filters.periodoLiq) params.periodo_liq = filters.periodoLiq
    if (filters.estadoId) params.estado = filters.estadoId
    if (filters.estadoUsuarioId === null) {
      params.user_status = -1
    } else {
      params.user_status = filters.estadoUsuarioId
    }

    return this.client.exec(
      `/v2/licensesUser/licenses${pagination}${order}`,
      'POST',
      params
    )
  }

  exportLicenses(filters, orderBy, descending) {
    let order = ''
    if (orderBy) {
      let type = descending ? 'desc' : 'asc'
      order = `?orderBy=${orderBy}&orderType=${type}`
    }

    let params = {}
    if (filters.userId) params.user_id = [filters.userId]
    if (filters.licenseTypeId) params.type_id = filters.licenseTypeId
    if (filters.periodoDesde) params.periodo_desde = filters.periodoDesde
    if (filters.periodoHasta) params.periodo_hasta = filters.periodoHasta
    if (filters.periodoLiq) params.periodo_liq = filters.periodoLiq
    if (filters.estadoId) params.estado = filters.estadoId
    if (filters.estadoUsuarioId === null) {
      params.user_status = -1
    } else {
      params.user_status = filters.estadoUsuarioId
    }

    return this.client.exec(
      `/v2/licensesUser/licenses/export${order}`,
      'POST',
      params
    )
  }

  exportLicensesBlob(filters, orderBy, descending) {
    let order = ''
    if (orderBy) {
      let type = descending ? 'desc' : 'asc'
      order = `?orderBy=${orderBy}&orderType=${type}`
    }

    let params = {}
    if (filters.userId) params.user_id = JSON.stringify([filters.userId])
    if (filters.licenseTypeId) params.type_id = filters.licenseTypeId
    if (filters.periodoDesde) params.periodo_desde = filters.periodoDesde
    if (filters.periodoHasta) params.periodo_hasta = filters.periodoHasta
    if (filters.periodoLiq) params.periodo_liq = filters.periodoLiq
    if (filters.estadoId) params.estado = filters.estadoId
    if (filters.estadoUsuarioId === null) {
      params.user_status = -1
    } else {
      params.user_status = filters.estadoUsuarioId
    }

    return this.client.getDownloadBlobFile(
      `/v2/licensesUser/licenses/export${order}`,
      params
    )
  }

  searchBalances(filters, perPage, page, orderBy, descending) {
    let pagination = ''
    let order = ''
    if (perPage && page) {
      pagination = `?pagination=${perPage},${page},0`
    }
    if (orderBy) {
      let type = descending ? 'desc' : 'asc'
      order = `&orderBy=${orderBy}&orderType=${type}`
    }

    let params = {}
    if (filters.userId) params.user_id = [filters.userId]
    if (filters.licenseTypeId) params.type_id = filters.licenseTypeId
    if (filters.periodo) params.periodo = filters.periodo
    if (filters.estadoUsuarioId === null) {
      params.user_status = -1
    } else {
      params.user_status = filters.estadoUsuarioId
    }

    return this.client.exec(
      `/v2/licensesUser/balances${pagination}${order}`,
      'POST',
      params
    )
  }

  exportBalances(filters, orderBy, descending) {
    let order = ''
    if (orderBy) {
      let type = descending ? 'desc' : 'asc'
      order = `?orderBy=${orderBy}&orderType=${type}`
    }

    let params = {}
    if (filters.userId) params.user_id = [filters.userId]
    if (filters.licenseTypeId) params.type_id = filters.licenseTypeId
    if (filters.periodo) params.periodo = filters.periodo
    if (filters.estadoUsuarioId === null) {
      params.user_status = -1
    } else {
      params.user_status = filters.estadoUsuarioId
    }

    return this.client.exec(
      `/v2/licensesUser/balances/export${order}`,
      'POST',
      params
    )
  }

  getExpiredLicenses(licensesIds) {
    return this.client.exec(
      `/licensesAdmin/daysToExpire?licenseId=[${licensesIds}]`,
      'GET'
    )
  }

  getTypeDocumentTemplate(idtypedocument) {
    return this.client.exec(
      `/v2/uploaddocuments/companyTypeDocuments/${idtypedocument}`,
      'GET'
    )
  }

  sendDocsToLincense(id, name, file) {
    delete file['UrlOnLoad']
    const body = {
      id: id,
      name: name,
      file: file
    }
    return this.client.exec(
      '/v2/uploaddocuments/uploadFile',
      'POST',
      body,
      true
    )
  }

  getUploadedDocument(licenseId) {
    if (typeof licenseId === 'number') {
      licenseId = licenseId.toString()
    }
    if (typeof licenseId !== 'string' || !/^[\w-]+$/.test(licenseId)) {
      throw new Error('Invalid licenseId format')
    }
    return this.client.getImageWithResponse(
      `/v2/licensesUser/file/${licenseId}`
    )
  }

  searchEmployeesAssigned(filter, searchInLicenses) {
    return this.client.exec(`/licensesUser/employeesAssigned`, 'GET', {
      filter: filter,
      searchInLicenses: searchInLicenses
    })
  }
}
